import {Box, Button, TextField, Typography} from "@mui/material";
import React, {useState} from "react";

const LoginModal = ({setValidToken}) => {

  const [userName,setUserName] = useState("");
  const [password,setPassword] = useState("");
  const [otpModal,setOtpModal] = useState(false);

  return (
    <Box sx={{p:3}} >
       {!otpModal && <><Typography align="center" sx={{ fontWeight: 'bold' }}>USPTO Login</Typography>
        <Box sx={{ display: 'flex', flexDirection : 'column', mt:4}}>
            <TextField required id="username" label="Username" value={userName} onChange={(e)=> setUserName(e.target.value)}/>
            <br></br>
            <TextField
            required
            value={password} 
            onChange={(e)=> setPassword(e.target.value)}
            id="password"
            label="Password"
            type="password"
            />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt:2 }}>
            <Button type="submit" variant="contained" onClick={()=> setOtpModal(true)}>Submit</Button>
        </Box></> }
        
        {otpModal && <Box>
            <TextField required id="username" label="Enter OTP" value={userName} onChange={(e)=> setUserName(e.target.value)} sx={{mb:2}}/>
            
            <Typography align="center" sx={{ fontStyle: 'italic', fontSize: 'small' }}>Note: Once the OTP is successfully submitted the session would be valid for 20 minutes</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt:2 }}>
            <Button type="submit" variant="contained" onClick={()=> setValidToken(true)}>Submit</Button>
            </Box>
        </Box>}
        
    </Box>
  );
}

export default LoginModal;